import type { ColumnDef } from '@tanstack/react-table';

import Toggle from 'components/partials/toggle/toggle';

export interface IncludedReportRow {
  id: string | number;
  title?: string;
  description?: string;
  productId?: string | number | null;
  powerBiId?: string | number;
  [key: string]: unknown;
}

const commonStyles = 'pl-4 border-r-2 border-white font-semibold';

export const getIncludedReportsTableSettings = (
  productId: string | number,
  handleToggleChange: (
    report: IncludedReportRow,
    newToggleValue: boolean
  ) => void
): ColumnDef<IncludedReportRow>[] => [
  {
    id: 'title',
    accessorKey: 'title',
    header: () => <span>REPORT NAME</span>,
    cell: (info) => info.renderValue(),
    headerClassName: `${commonStyles} cursor-pointer rounded-tl-md rounded-bl-md`,
    className: 'pl-4 tablet:w-[30%] font-semibold',
    enableSorting: true,
    sortingFn: 'alphanumeric',
  } as ColumnDef<IncludedReportRow>,
  {
    id: 'description',
    accessorKey: 'description',
    header: () => <span>DESCRIPTION</span>,
    cell: (info) => <span>{info.renderValue() as React.ReactNode}</span>,
    headerClassName: `${commonStyles}`,
    className: 'pl-4 tablet:w-[63%]',
    enableSorting: false,
  } as ColumnDef<IncludedReportRow>,
  {
    id: 'linked',
    accessorKey: 'productId',
    header: () => <span>LINKED</span>,
    cell: ({ row: { original: report } }) => {
      const isIncluded = report.productId == productId;

      return (
        <Toggle
          isToggleOn={isIncluded}
          onToggleChange={(newValue) => handleToggleChange(report, newValue)}
          data-testid="included-reports-table-toggle"
        />
      );
    },
    headerClassName: 'h-12 rounded-tr-md rounded-br-md font-semibold',
    className: 'py-3 pl-4',
    enableSorting: false,
  } as ColumnDef<IncludedReportRow>,
];
